import type { EntityLoaders } from 'entities/modules';
import type { LoadConfig } from '../load/types';

type StringKey<T> = Extract<T, string>;

type LoadAction<AppLoaders extends LoadConfig> = {
  [Module in StringKey<keyof AppLoaders>]: `${Module}.${StringKey<keyof AppLoaders[Module]>}`;
}[StringKey<keyof AppLoaders>];

export type AppQuery = LoadAction<EntityLoaders>;

export function queryToKeyPrefix(query: AppQuery) {
  return query.split('.');
}
